<template lang="pug">
form(class='image-upload' ref='form')
  div(class='image-upload-wrap')
    v-text-field(:label='label' v-model='name' prepend-icon='attach_file' hint='Допустимые форматы: jpg, png, gif, svg' persistent-hint)
      template(v-slot:append-outer)
          v-icon(
            :color="iconColor"
          ) cloud_upload
    //- Триггер выбора файла
    input(@change='readFile' accept='image/*' type='file' ref='image')
      //- Контейнер для изображения
  v-card(v-if='image' class='image-upload-preview mt-4')
    div(class='controls')
      v-spacer
      //- Кнопка триггерит событие вызова редактора
      v-tooltip(v-if='editor' top)
        v-btn(@click.stop='$emit("editor")' slot='activator' icon class='act-btn')
          v-icon(color='grey') format_shapes
        | Редактор планировки
      //- Кнопка триггерит событие переключения режима превью/не превью
      v-tooltip(v-if='scheme===true && image' top)
        v-btn(@click.stop='preview=!preview' slot='activator' icon class='act-btn')
          v-icon(color='grey') {{ preview ? 'visibility_off' : 'visibility' }}
        | {{ preview ? "Скрыть планировку" : "Показать планировку"  }}
      //- Кнопка триггерит открытие ссылки на картинику
      v-tooltip(v-if='image' top)
        v-btn(@click.stop='openUrl' slot='activator' icon class='act-btn')
          v-icon(color='grey') image
        | Открыть ссылку
      //- Кнопка триггерит событие удаления изображения
      v-tooltip(top)
        v-btn(@click.stop='remove' slot='activator' icon class='act-btn')
          v-icon(color='grey') delete_outline
        | Удалить

    v-img(:style='{ opacity: preview ? 0 : 1 }' :aspect-ratio='imgRatio' :lazy-src='image' :src='image' class='grey lighten-4' contain)
      v-layout(slot='placeholder' fill-height align-center justify-center ma-0)
        v-progress-circular(indeterminate color='primary')
    //- Доп слот для кастомных превьюшек, например SVG
    div(v-if='preview' @click.stop class='extension')
      slot(name='extension')
</template>

<script>
import http from '@/http'

export default {
  props: {
    label: {
      type: String,
      default: 'Выберите файл для загрузки'
    },
    src: String,
    editor: Boolean,
    scheme: Boolean,
    parseResponse: {
      type: Function,
      default: v => v
    },
    ratio: {
      // type: String,
      default: 16 / 9
    },
    recordId: {
      type: Number,
      default: null
    },
    hasPreview: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    name: null,
    image: null,
    preview: false,
    busy: false,
    loaded: null,
    hash: null
  }),

  created() {
    this.image = this.src
    this.preview = this.hasPreview
  },

  methods: {
    async upload(file) {
      if (this.busy) return
      this.busy = true
      this.loaded = false

      let formdata = new FormData()
      // let extension = file.name.split('.').pop()
      formdata.append('attachFile', file, file.name)

      try {
        let response = await http.post('/files/upload', formdata)
        this.$emit('input', this.parseResponse(response.data.hash))
        this.$emit('upload-success', response.data)
        this.loaded = true
      } catch (error) {
        this.$emit('upload-error', error)
      }

      this.busy = false
    },

    async remove() {
      if (this.busy || !(await this.$confirm('Удалить изображение?'))) return

      this.busy = true

      try {
        const hash =
          typeof this.$attrs.value === 'string'
            ? this.$attrs.value
            : this.$attrs.value.hash

        let response = await http.delete(`/files/delete/${hash}`, {
          record_id: this.recordId
        })

        this.image = null

        this.$emit('input', null)
        this.$emit('remove-success', response)

        this.$nextTick(() => this.$refs.form.reset())
      } catch (error) {
        this.$emit('remove-error', error)
      }

      this.busy = false
    },

    openUrl() {
      if (!this.image) return
      window.open(this.image, '_blank');

    },

    readFile(event) {
      let imageType = /image.*/
      let file = event.target.files[0]

      if (file && file.type.match(imageType)) {
        this.name = file.name

        this.$refs.form.reset()
        let reader = new FileReader()

        reader.onload = () => {
          this.image = reader.result
        }

        reader.readAsDataURL(file)
        this.upload(file)
      } else {
        this.$root.showSnack('Неподдерживаемый формат файла')
      }
    }
  },

  watch: {
    src(val) {
      this.image = val
    },
    hasPreview(val) {
      this.preview = val
    }
  },

  computed: {
    imgRatio() {
      if ('auto' === this.ratio+'') return
      return this.ratio
    },
    iconLoader() {
      return this.busy ? 'mdi-eye' : 'mdi-eye-off';
    },
    iconColor() {
      // Меняем цвет в зависимости от длины пароля
      if (this.loaded === null) return 'grey';
      return this.loaded===true ? 'success' : 'error';
    }
  }
}
</script>

<style scoped>
.image-upload-wrap {
  overflow: hidden;
  position: relative;
}
.image-upload [type='file'] {
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 50px;
  position: absolute;
}
.image-upload-preview {
  padding-bottom: 48px;
  overflow: hidden;
  pointer-events: none;
}
.controls {
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
  position: absolute !important;
  background: white;
  display: flex;
  align-items: flex-end;
  pointer-events: auto;
}
.extension {
  top: 48px;
  right: 0;
  bottom: 0px;
  left: 0;
  position: absolute;
}
.act-btn:hover >>>.v-icon{
  color: inherit !important;
}
</style>
